const SCREEN = {
  WEB_KYC_ONBOARDING: 'KYCOnboarding',
  WEB_PAIDY_FORM: 'Paidy+ Form',
  WEB_CONTINUE_PAIDY_FORM: 'Continue Paidy+ Form',
  WEB_KYC_FORM_COMPLETE_SCREEN: 'KYCFormCompleteScreen',
};

const ITEM = {
  // PAGE VIEW
  WEB_EKYC_ONBOARDING_SLIDE: 'eKYC Onboarding Slide - ',
  WEB_EKYC_ONBOARDING_SLIDE_PICK_LOCATION: 'eKYC Onboarding - Pick Location',
  WEB_EKYC_ONBOARDING_SLIDE_SCAN_QR_CODE: 'eKYC Onboarding - Scan QR Code',
  WEB_EKYC_ONBOARDING_SELECT_DOCUMENT: 'eKYC Onboarding - Selecting Document',
  WEB_EKYC_ONBOARDING_LIQUID_WARNING: 'eKYC Onboarding  Liquid Warning',
  WEB_EKYC_ONBOARDING_LIQUID_T_AND_C: 'eKYC Onboarding  Liquid T&C',

  WEB_EKYC_PAIDY_FORM_PERSONAL: 'personal',
  WEB_EKYC_PAIDY_FORM_ADDRESS: 'address',
  WEB_EKYC_PAIDY_FORM_ADDITIONAL: 'additional',
  WEB_EKYC_PAIDY_FORM_PEP: 'pep',
  WEB_EKYC_PAIDY_FORM_CONFIRMATION: 'confirmation',

  // CLICK
  WEB_EKYC_ONBOARDING_VERIFY: 'KYCOnboarding - Verify',
  WEB_EKYC_ONBOARDING_NO_VERIFY: 'KYCOnboarding - No Verify',
  WEB_EKYC_ONBOARDING_EKYC_INFO: 'KYCOnboarding - info Screen',
  WEB_EKYC_ONBOARDING_PICK_LOCATION_APP: 'KYCOnboarding - Pick Location App',
  WEB_EKYC_ONBOARDING_PICK_LOCATION_MOBILE_WEB:
    'KYCOnboarding - Pick Location Mobile Web',
  WEB_EKYC_ONBOARDING_PICK_LOCATION_DESKTOP:
    'KYCOnboarding - Pick Location Desktop',
  WEB_EKYC_ONBOARDING_SCAN_QR_CODE: 'KYCOnboarding - Scan QR Code',
  WEB_EKYC_ONBOARDING_PICK_ID_TYPE_DL: 'ID Type DL',
  WEB_EKYC_ONBOARDING_PICK_ID_TYPE_MNC: 'ID Type MNC',
  WEB_EKYC_ONBOARDING_VERIFY_T_AND_C: 'WebKYCOnboarding - Verify T&C',
  WEB_EKYC_ONBOARDING_VERIFY_T_AND_C_LINK: 'Liquid T&C Link',
  WEB_EKYC_ONBOARDING_PAIDY_T_AND_C_LINK: 'Paidy T&C Link',

  WEB_EKYC_COMPLETE: 'KYC Complete',
  WEB_EKYC_WHAT_IS_PEP: 'What Is PEPs',
  WEB_EKYC_SUBMIT: 'Submit',
  WEB_EKYC_BACK: 'Back',
  WEB_EKYC_PEP_WARNING_CONTINUE: 'PEPs Warning - Continue',
  WEB_EKYC_PEP_WARNING_CANCEL: 'PEPs Warning - Cancel',
  WEB_EKYC_PEP_WARNING: 'PEPs Warning',

  WEB_EKYC_RETRY_AFTER_DROP_OFF: 'KYC Retry After Drop Off',
};

const ACTION = {
  PAGE_VIEW: 'Page View',
  CLICK: 'Click',
  SUCCESS: 'Success',
  ERROR: 'Error',
  FIELD_EDIT: 'Field Edit',
};

export { ACTION, ITEM, SCREEN };
